const setHomeType = (payload) => {
  return {
    type: "homeSubtypeChange",
    payload,
  };
};
export default setHomeType;
